import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import {
  Stack,
  Table,
  Dialog,
  Button,
  Divider,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  Typography,
  DialogContent,
  DialogActions,
  TableContainer,
} from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import axios, { endpoints } from 'src/utils/axios';
import { toastError } from 'src/utils/format-error';
import * as Yup from 'yup';

import { fNumber } from 'src/utils/format-number';
import { DepositTxType } from 'src/type/deposit';
import useCurrentDateTime from 'src/hooks/use-current-date-time';

type ApproveDialogProps = {
  open: boolean;
  onClose: () => void;
  tx: DepositTxType;
  handleReload: () => void;
};

export default function DepositRejectDialog({
  open,
  onClose,
  tx,
  handleReload,
}: ApproveDialogProps) {
  const currentDateTime = useCurrentDateTime();

  const Schema = Yup.object().shape({
    note: Yup.string(),
  });

  const defaultValues = {
    note: '',
  };

  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(Schema),
    defaultValues,
  });

  const {
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = methods;

  const beforeClose = () => {
    reset(defaultValues);
    onClose();
  };

  const onSubmit = handleSubmit(async (values) => {
    try {
      await axios.post(endpoints.transactions.deposit.reject(tx.id), {
        note: values.note,
        currentDateTime,
      });

      handleReload();
      beforeClose();
      enqueueSnackbar('อัพเดทข้อมูลสำเร็จ', { variant: 'success' });
    } catch (error) {
      toastError(error);
    }
  });

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <Stack direction="row" alignItems="center" sx={{ p: 3 }}>
          <Typography variant="h6">
            ปฏิเสธการฝาก {tx.product.name} {tx.amount} {tx.unitName}
          </Typography>
        </Stack>

        <DialogContent>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell align="center">น้ำหนัก</TableCell>
                  <TableCell align="center">จำนวน</TableCell>
                  {/* <TableCell align="center">ค่าธรรมเนียม</TableCell> */}
                </TableRow>
              </TableHead>

              <TableBody>
                {tx?.productRedeemFees?.map((fee) => (
                  <TableRow key={fee.id}>
                    <TableCell>{fee?.productRedeemFee?.name}</TableCell>
                    <TableCell align="center">
                      {fee?.productRedeemFee?.weight} {fee.productRedeemFee?.unitName}
                    </TableCell>
                    <TableCell align="center">{fNumber(fee?.amount || 0)}</TableCell>
                    {/* <TableCell align="center">
                    {fNumber((fee?.amount || 0) * (fee?.productRedeemFee?.fee || 0))}
                  </TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>

            <Divider style={{ borderStyle: 'dashed' }} />

            <Table size="small" sx={{ my: 3 }}>
              <TableHead>
                <TableRow>
                  <TableCell>น้ำหนักทองทั้งหมด</TableCell>
                  <TableCell align="center">
                    {fNumber(tx?.amount || 0)} {tx.unitName}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>ค่าธรรมเนียมทั้งหมด</TableCell>
                  <TableCell align="center">{fNumber(tx?.fee || 0)} THB</TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>

          <RHFTextField
            multiline
            rows={3}
            name="note"
            placeholder="หมายเหตุ"
            InputLabelProps={{ shrink: true }}
          />
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={beforeClose} disabled={isSubmitting}>
            ยกเลิก
          </Button>
          <LoadingButton variant="contained" type="submit" loading={isSubmitting}>
            ดำเนินการต่อ
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}
